import { render } from "./App.vue?vue&type=template&id=410ad074"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=410ad074&lang=scss"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/beatentodeath/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__